import { z } from 'zod';
import { IObject } from '../IObject';
import { EmailEventRecordType } from '../enums';

export const EmailEventDataSchema = z.object({
  // Whatever the provider named the event: a record type we do not know yet is
  // still stored, so the events of a new Paubox type are not lost
  RecordType: z.custom<EmailEventRecordType>(
    (value) => value !== undefined && value !== null,
    'RecordType is required',
  ),
});

export type EmailEventData = z.infer<typeof EmailEventDataSchema>;
export type EmailEvent = IObject.HasIdTimestamped<EmailEventData>;
